import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import { makeInput, Loading } from "common-import/custom";
import { contractorImage } from "common-import/constants";
import { VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

const StatusList = {
  'all': 'All',
  'approved': 'Approved',
  'not-approved': 'Not Approved',
  'not-approved-update': 'Not Approved (update)',
};

@inject("contractorStore", "userStore", "routeStore") @observer
export default class ContractorList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      keyword: "",
      page: 1,
      status: 'all',
      list: [],
    }
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    await this.getList();
    this.setState({isLoading: false});
  }

  renderRow = (data, index) => {
    return (
      <tr key={"row"+index}>
        <td className="text-center">
          <div className="avatar">
            <img src={VarHelper.img(data.logo) || defaultImage} className="img-avatar" alt=""/>
            {/* <span className="avatar-status badge-success"></span> */}
          </div>
        </td>
        <td>
          <Link to={this.props.routeStore.admin.contractorDetail(data.id, data.contractor)}>
            <div>{data.contractor}</div>
            <div className="small text-muted">
              <span>Email</span>: {data.email}
            </div>
            <div className="small text-muted">
              <span>Tel</span>: {data.tel}
            </div>
            <div className="small text-muted">
              <span>Fax</span>: {data.fax}
            </div>
            <div className="small text-muted">
              <span>Id</span>: {data.id}
            </div>
          </Link>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.address}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.license}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="small text-muted">{data.website}</div>
        </td>
        <td>
          <div className="small text-muted">{data.ranking}</div>
        </td>
      </tr>

    )
  };

  render() {
    let { isLoading, list } = this.state;
    list = list.slice();
    if (isLoading) return (<Loading> </Loading>);
    return (
      <div className="animated fadeIn">
        <Form onSubmit={this.search}>
          <FormGroup>
            <Button type="button" color="primary" onClick={this.search} className="mb-8"><i className="fa fa-search"> </i> Search</Button>
            {makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Contractor's name" />)}
          </FormGroup>
        </Form>
        <div className="form">
          <div className="form-group" style={{width:'200px'}}>
            <select value={this.state.status} className="form-control" onChange={(e) => this.setState({status: e.target.value, page: 1}, () => this.getList())}>
              {
                Object.entries(StatusList).map(([key, value]) => {
                  return <option key={key} value={key}>{value}</option>
                })
              }
            </select>
          </div>
        </div>
        <Row>
          <Col xs="12" sm="12">
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
              <tr>
                <th className="text-center"><i className="icon-people"></i></th>
                <th>Contractor</th>
                <th>Address</th>
                <th>License Number</th>
                <th>Website</th>
                <th>Ranking</th>
              </tr>
              </thead>
              <tbody style={{backgroundColor: 'white'}}>
              {list.length > 0 && list.map((val, index) => this.renderRow({
                id: val.id,
                contractor: val.name,
                email: val.email,
                tel: val.phone,
                fax: val.fax,
                address: val.address,
                license: "Contractor",
                website: val.website,
                ranking: val.totalRanking,
                logo: val.logo
              }, index) )}
              </tbody>
            </Table>
            {list.length === 0 && <p style={{ marginTop: 20, testAlign: "center", display: "block" }}>Data Empty</p>}
          </Col>
        </Row>
        <Row style={{marginTop: 20, marginBottom: 20}}>
          <Col xs="12" md="12">
            <Pagination>
              <PaginationItem>
                <PaginationLink previous onClick={this.loadPrev}/>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>{this.state.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next onClick={this.loadNext} />
              </PaginationItem>
            </Pagination>
          </Col>
        </Row>
      </div>
    );
  }

  search = async e => {
    !!e && e.preventDefault();
    const { keyword, status } = this.state;
    if (keyword == "") {
      return this.getList();
    }
    const { contractorStore } = this.props;
    let approved;
    switch (status) {
      case 'all': {
        approved = undefined;
        break;
      }
      case 'approved': {
        approved = 1;
        break;
      }
      case 'not-approved': {
        approved = 0;
        break;
      }
      case 'not-approved-update': {
        approved = 3;
        break;
      }
    }
    const { data } = await contractorStore.search(keyword, approved);
    this.setState({ list: data || [] });
  };

  loadPrev = e => {
    !!e && e.preventDefault();
    if (this.state.page === 1) return;
    this.setState({ page: this.state.page - 1}, () => {
      this.getList();
    });
  };

  loadNext = e => {
    !!e && e.preventDefault();
    this.setState({ page: this.state.page + 1}, () => {
      this.getList();
    });
  };

  getList = async () => {
    const { status, page } = this.state;
    const { contractorStore } = this.props;
    switch (status) {
      case 'all': {
        await contractorStore.getAll(page);
        this.setState({list: contractorStore.listAll});
        break;
      }
      case 'approved': {
        await contractorStore.getListApproved(page);
        this.setState({list: contractorStore.listApproved});
        break;
      }
      case 'not-approved': {
        await contractorStore.getListNotApproved(page);
        this.setState({list: contractorStore.listNotApproved});
        break;
      }
      case 'not-approved-update': {
        await contractorStore.getListNotApprovedUpdate(page);
        this.setState({list: contractorStore.listNotApproved});
        break;
      }
    }
  };
}




// WEBPACK FOOTER //
// ./src/views/Contractors/List.js